import { repository, baseURL, cancelToken } from '@/api/base'

let cancel = null

export default {
  async getCatalog(page, filter) {
    cancel && cancel()

    const { data } = await repository.post(`${baseURL}/dictionary/magazine/findAll/${page}`, {
      name: filter
    })
    return data
  },

  async create(body) {
    const { data } = await repository.post(baseURL + '/dictionary/magazine', body)
    return data
  },

  async update(body) {
    const { data } = await repository.put(baseURL + '/dictionary/magazine', body)
    return data
  },

  async remove(id) {
    return await repository.delete(baseURL + '/dictionary/magazine/' + id)
  },

  async findAllByName(searchString) {
    cancel && cancel()

    const { data } = await repository.get(baseURL + '/dictionary/magazine/findAllByName?name=' + searchString, {
      cancelToken: new cancelToken(c => (cancel = c))
    })
    return data
  }
}
